






import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomIconRemove extends ComponentVue {
  @Prop({
    type: Boolean
  })
  disabled!: boolean

  get style(): any {
    if (this.disabled) {
      return { 'pointer-events': 'none', color: 'red', opacity: 0.5 }
    }

    return ''
  }

  @Emit('click')
  onClick() {}
}
